import angular from "angular";
import panel from "../services";

function questionsMatch (panel) {

    return {
        restrict: 'E',
        scope: {
            questions: '='
        },
        link: function(scope) {
        },
        template: require('./templates/questions-match.html')
    }
};

export default angular.module('directives.questionsMatch', [panel]).directive('questionsMatch', questionsMatch).name;


// WEBPACK FOOTER //
// ./src/app/directives/questionsMatch.js